import React, { ReactElement } from 'react';
import ChipInternal from '@mui/material/Chip';
import CancelFilledIcon from '../../icons/cancel-filled-icon';
import ImageAvatar from '../image-avatar/image-avatar.component';
import StructureService from '../../services/structure-service';
import FormatService from '../../services/format-service';
import useStylesChip from './chip.styles';
import POINTER_KEY_PRIMARY from '../../constants/system/pointer-keys';

const Chip: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const COLOR_PRIMARY: ThemeColor = 'primary';
  const COLOR_SECONDARY: ThemeColor = 'secondary';
  const CHIP_VARIANT_OUTLINED: ChipVariant = 'outlined';

  const {
    isDisabled,
    isHighlighted,
    withDelete,
    withImageOffset,
    label,
    imageLink,
    onClick,
    onDelete,
  } = props;

  const { classes } = useStylesChip();

  const highlightedClassName: string | undefined = isHighlighted ? classes.chipHighlighted : undefined;
  const disabledClassName: string | undefined = isDisabled ? classes.chipDisabled : undefined;
  const deleteIconHighlightedClassName: string | undefined = isHighlighted
    ? classes.chipDeleteIconHighlighted : undefined;
  const labelHighlightedClassName: string | undefined = isHighlighted ? classes.chipLabelHighlighted : undefined;
  const imageOffsetClassName: string | undefined = withImageOffset ? classes.chipImageOffset : undefined;

  return (
    <ChipInternal
      label={label}
      className={FormatService.formatClassNames(classes.chip, highlightedClassName, disabledClassName)}
      classes={{
        label: labelHighlightedClassName,
      }}
      variant={CHIP_VARIANT_OUTLINED}
      color={isHighlighted ? COLOR_SECONDARY : COLOR_PRIMARY}
      onClick={onClick}
      avatar={(
        imageLink && (
          <ImageAvatar
            text={label}
            link={imageLink}
            className={imageOffsetClassName}
          />
        )
      )}
      onDelete={withDelete && onDelete && !isDisabled ? StructureService.emptyAction : undefined}
      deleteIcon={(
        withDelete && onDelete && !isDisabled ? (
          <CancelFilledIcon
            className={FormatService.formatClassNames(classes.chipDeleteIcon, deleteIconHighlightedClassName)}
            onPointerDown={(event: React.PointerEvent): void => {
              if (event.button === POINTER_KEY_PRIMARY) {
                event.stopPropagation();
                event.preventDefault();

                onDelete(event);
              }
            }}
          />
        ) : undefined
      )}
    />
  );
});

export default Chip;
